import axios from 'axios'

const state = {
  users: [],
  loading: false,
  error: null
}

const getters = {
  allUsers: state => state.users,
  isLoading: state => state.loading,
  error: state => state.error
}

const actions = {
  async fetchUsers({ commit }) {
    commit('SET_LOADING', true)
    
    try {
      const response = await axios.get('/api/users', { withCredentials: true })
      commit('SET_USERS', response.data.users)
      return { success: true }
    } catch (error) {
      const errorMessage = error.response ? error.response.data.error : 'Failed to fetch users'
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async createUser({ commit, dispatch }, userData) {
    try {
      await axios.post('/api/users', userData, { withCredentials: true })
      // Refresh users list
      await dispatch('fetchUsers')
      return { success: true, message: 'User created successfully' }
    } catch (error) {
      return { success: false, error: error.response ? error.response.data.error : 'Failed to create user' }
    }
  },
  
  async updateUser({ commit, dispatch }, { userId, userData }) {
    try {
      await axios.put(`/api/users/${userId}`, userData, { withCredentials: true })
      // Refresh users list
      await dispatch('fetchUsers')
      return { success: true, message: 'User updated successfully' }
    } catch (error) {
      return { success: false, error: error.response ? error.response.data.error : 'Failed to update user' }
    }
  }
}

const mutations = {
  SET_USERS(state, users) {
    state.users = users
  },
  
  SET_LOADING(state, status) {
    state.loading = status
  },
  
  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}